/* eslint-disable */
import { getFeature } from '@/methods/feature';

export const RRS_ETRN_FEATURE_KEY = 'rrs.etrn.enabled';
export const RRS_ETRN_NOTIFICATION_FEATURE_KEY = 'rrs.etrn.notification.enabled';

const state = {
  rrsEtrn: false,
  rrsEtrnChecked: false,
  rrsEtrnNotification: false,
  rrsEtrnNotificationChecked: false,
};

const getters = {};

const mutations = {
  SET_RRS_ETRN(state, value) {
    state.rrsEtrn = value;
    state.rrsEtrnChecked = true;
  },
  SET_RRS_ETRN_NOTIFICATION(state, value) {
    state.rrsEtrnNotification = value;
    state.rrsEtrnNotificationChecked = true;
  },
};

const actions = {
  async checkRrsEtrn({ commit, state }) {
    // Флаг проверяем один раз за сессию: при последующих переходах/рендерах меню
    // возвращаем уже полученное значение без повторного запроса
    if (state.rrsEtrnChecked) {
      return state.rrsEtrn;
    }

    try {
      const response = await getFeature(RRS_ETRN_FEATURE_KEY);
      const enabled = 'success' in response.data && response.data.success
        ? response.data.data?.enabled === true
        : false;

      commit('SET_RRS_ETRN', enabled);
      commit('menu/SET_ETRN_AVAILABILITY', enabled, { root: true });

      return enabled;
    } catch (error) {
      commit('SET_RRS_ETRN', false);
      commit('menu/SET_ETRN_AVAILABILITY', false, { root: true });

      return false;
    }
  },

  async checkRrsEtrnNotification({ commit, state }) {
    // Флаг проверяем один раз за сессию
    if (state.rrsEtrnNotificationChecked) {
      return state.rrsEtrnNotification;
    }

    try {
      const response = await getFeature(RRS_ETRN_NOTIFICATION_FEATURE_KEY);
      const enabled = 'success' in response.data && response.data.success
        ? response.data.data?.enabled === true
        : false;

      commit('SET_RRS_ETRN_NOTIFICATION', enabled);

      return enabled;
    } catch (error) {
      commit('SET_RRS_ETRN_NOTIFICATION', false);

      return false;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
